import React from 'react'

import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const HeightGarageField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  const { t } = useTranslation()
  return (
    <div className={getDefaultClasses('right')}>
      <TextInput
        id='height-garage'
        propertyName='heightGarage'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.heightGarage', 'Height of Garage')}</span>}
        value={insertionData.heightGarage}
        maxLength={5}
        type='text'
        affixRight='unit'
        unitRight='meters'
        errors={validationMessages?.heightGarage ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default HeightGarageField
